import React, { useState, useEffect } from "react";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import axios from "axios";
import SearchIcon from "@material-ui/icons/Search";
import Fab from "@material-ui/core/Fab";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";

import Snackbar from "@material-ui/core/Snackbar";

import MovieTorrent from "./MovieTorrent";
import PageLoad from "./components/pageload/PageLoad";

const List = () => {
  const [searchText, setsearchText] = useState("breaking bad");
  const [result, setresult] = useState([]);
  const [result2, setresult2] = useState([]);
  const [open, setOpen] = React.useState(false);

  const [detailbool, setdetailbool] = useState(false);
  const [imval, setimval] = useState();

  const filmChange = (event) => {
    setsearchText(event.target.value.toLowerCase());
  };
  const film = () => {
    axios
      .get(`https://www.omdbapi.com/?apikey=4eb65943&s=${searchText}`)
      .then((res) => {
        setresult(res.data.Search.map((p) => p));
      })
      .catch((error) => {
        //alert("No search results found!! check for spelling ");
        setOpen(true);
      });
    film2();
  };

  const film2 = () => {
    axios
      .get(`https://www.omdbapi.com/?apikey=5fcb333a&s=${searchText}&page=2`)
      .then((res) => {
        setresult2(res.data.Search.map((s) => s));
      })
      .catch((error) => {});
  };
  function filmDetail(i) {
    setdetailbool(true);
    setimval(i);
  }
  //to toggle boolean
  function funsetdetailbool() {
    setdetailbool(false);
  }

  useEffect(() => {
    film();
  }, []);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <React.Fragment>
      <PageLoad />
      <center>
        <div className=" navbar">
          <img
            className="navbar-img"
            src={require("./images/6movies-item.png")}
            alt="Website Logo"
          />
          <br />
          <input
            type="text"
            value={searchText}
            onChange={filmChange}
            placeholder="Search Movies And Series"
            className="navbar-search"
          />
          <Fab
            color="primary"
            aria-label="add"
            style={{
              background: "#b71c1c",
              margin: "0px",
              borderRadius: "50px",
              fontSize: "60px",
            }}
            onClick={film}
          >
            <SearchIcon />
          </Fab>
          <br />
          <br />
        </div>
        <br />
        <center>
          <div className="resultContainer">
            {result.map((p) => (
              <div key={p.imdbID} onClick={() => filmDetail(p.imdbID)}>
                <Card className="movieCard">
                  <CardActionArea>
                    <img className="moviePoster" src={p.Poster} alt={p.Title} />

                    <span
                      variant="contained"
                      style={{
                        position: "absolute",
                        top: "0px",
                        right: "0px",
                        background: "rgba(0, 0, 0, 0.5)",
                        color: "white",
                        borderRadius: "4px",
                      }}
                      >
                      {p.Year}
                    </span>
                    <div className="middle">
                      <div className="text">
                        <PlayCircleFilledIcon
                          className="playHoverIcon"
                          fontSize="large"
                          style={{ color: "#aa2e25", fontSize: "60px" }}
                          />
                      </div>
                    </div>
                  </CardActionArea>
                </Card>
                <h1>{p.Title}</h1>
              </div>
            ))}

            {/* result2 */}
            {result2.map((s) => (
              <div key={s.imdbID} onClick={() => filmDetail(s.imdbID)}>
                <Card className="movieCard">
                  <CardActionArea>
                    <img className="moviePoster" src={s.Poster} alt={s.Title} />

                    <span
                      variant="contained"
                      style={{
                        position: "absolute",
                        top: "0px",
                        right: "0px",
                        background: "rgba(0, 0, 0, 0.5)",
                        color: "white",
                        borderRadius: "4px",
                      }}
                      >
                      <b> {s.Year}</b>
                    </span>
                    <div className="middle">
                      <div className="text">
                        <PlayCircleFilledIcon
                          className="playHoverIcon"
                          fontSize="large"
                          style={{ color: "#aa2e25", fontSize: "60px" }}
                          />
                      </div>
                    </div>
                  </CardActionArea>
                </Card>
                <h1>{s.Title}</h1>
              </div>
            ))}
          </div>
        </center>
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={open}
          autoHideDuration={1500}
          onClose={handleClose}
          style={{ marginTop: "20vh" }}
          message="No search results found !!"
        />

        {detailbool ? (
          <MovieTorrent
            imval={imval}
            funsetdetailbool={funsetdetailbool}
          />
        ) : null}
      </center>
    </React.Fragment>
  );
};
export default List;



// WEBPACK FOOTER //
// ./src/List.js